import type { PickActions } from '@recruitee/ngrx';
import { createEntityCollectionStore, getEntityCollectionActions } from '@recruitee/ngrx';
import type { PipelineTemplateListItem } from '@recruitee/pipeline-templates-types';

export const offerScope = (id: number) => `offer:${id}`;
const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer } = createEntityCollectionStore<PipelineTemplateListItem>()(
  'PipelineTemplateOfferListItem',
  {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: (state, payload: { offerId: number }) =>
          defaultActions.fetchCollection(state, { scope: offerScope(payload.offerId) }),
      };
    },
  },
);

const PipelineTemplateOfferListItemActions: PickActions<typeof actions, 'fetchCollection'> =
  actions;

export { PipelineTemplateOfferListItemActions, reducer as PipelineTemplateOfferListItemReducer };
